import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { CardModule } from 'primeng/card';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-landing',
  imports: [CardModule, RouterOutlet],
  templateUrl: './landing.html',
  styleUrl: './landing.css',
})
export class Landing implements OnInit {
  pageTitle = 'Backoffice';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.route;

        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        this.pageTitle = currentRoute.snapshot.title
          ? `Backoffice - ${currentRoute.snapshot.title}`
          : 'Backoffice';
      });
  }
}
